<template>
  <div>
    <TimeAbsoluteInput
      v-if="singleOrderSchema"
      :value="value"
      :label="label"
      @update:value="$emit('update:value', $event)"
    />
    <TimeReferenceInput
      v-else
      :value="value"
      :allowed-types="allowedTypes"
      @update:value="$emit('update:value', $event)"
    />
  </div>
</template>

<script>
import moment from 'moment';
import TimeAbsoluteInput from './TimeAbsoluteInput';
import TimeReferenceInput from './TimeReferenceInput';

export default {
  props: {
    value: String,
    label: String,
    defaultReference: String,
    singleOrderSchema: Boolean,
    allowedTypes: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
  }),
  components: {
    TimeReferenceInput,
    TimeAbsoluteInput,
  },
  watch: {
    singleOrderSchema() {
      this.init();
    },
  },
  methods: {
    init() {
      if (this.singleOrderSchema) {
        this.$emit('update:value', moment().format('YYYY-MM-DD'));
      } else {
        this.$emit('update:value', this.defaultReference);
      }
    },
  },
  created() {
    if (!this.value) {
      this.init();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
